import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AuthBackLinkProps {
  to?: string;
  label?: string;
  className?: string;
}

/** Text back link used on auth surfaces. Default returns to the full login page. */
export function AuthBackLink({
  to = '/login',
  label = 'Kembali ke Halaman Login',
  className,
}: AuthBackLinkProps) {
  return (
    <Link
      to={to}
      className={cn('inline-flex items-center gap-2 text-sm text-muted-foreground', className)}
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Link>
  );
}
